/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListingReference } from './ListingReference';
import {
    ListingReferenceFromJSON,
    ListingReferenceFromJSONTyped,
    ListingReferenceToJSON,
    ListingReferenceToJSONTyped,
} from './ListingReference';

/**
 * 
 * @export
 * @interface ArtifactWidgetListingDetailsContent
 */
export interface ArtifactWidgetListingDetailsContent {
    /**
     * Originating artifact's id.
     * @type {string}
     * @memberof ArtifactWidgetListingDetailsContent
     */
    artifactId?: string;
    /**
     * 
     * @type {ListingReference}
     * @memberof ArtifactWidgetListingDetailsContent
     */
    listingReference: ListingReference;
}

/**
 * Check if a given object implements the ArtifactWidgetListingDetailsContent interface.
 */
export function instanceOfArtifactWidgetListingDetailsContent(value: object): value is ArtifactWidgetListingDetailsContent {
    if (!('listingReference' in value) || value['listingReference'] === undefined) return false;
    return true;
}

export function ArtifactWidgetListingDetailsContentFromJSON(json: any): ArtifactWidgetListingDetailsContent {
    return ArtifactWidgetListingDetailsContentFromJSONTyped(json, false);
}

export function ArtifactWidgetListingDetailsContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtifactWidgetListingDetailsContent {
    if (json == null) {
        return json;
    }
    return {
        
        'artifactId': json['artifactId'] == null ? undefined : json['artifactId'],
        'listingReference': ListingReferenceFromJSON(json['listingReference']),
    };
}

export function ArtifactWidgetListingDetailsContentToJSON(json: any): ArtifactWidgetListingDetailsContent {
    return ArtifactWidgetListingDetailsContentToJSONTyped(json, false);
}

export function ArtifactWidgetListingDetailsContentToJSONTyped(value?: ArtifactWidgetListingDetailsContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'artifactId': value['artifactId'],
        'listingReference': ListingReferenceToJSON(value['listingReference']),
    };
}

